// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/mind-body-increased-blood-pressure.svg';

export const MindBodyIncreasedBloodPressure = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
